goog.provide("shadow.js.shim.module$$mui$material$ListItemButton");
goog.provide("module$shadow_js_shim_module$$mui$material$ListItemButton");
shadow.js.shim.module$$mui$material$ListItemButton = shadow.js.nativeProvides["@mui/material/ListItemButton"] = shadow$bridge("@mui/material/ListItemButton");
module$shadow_js_shim_module$$mui$material$ListItemButton.default = shadow.js.shim.module$$mui$material$ListItemButton;
